/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-expressions */
import { useContext, useState } from 'react'
import { MovementsContext } from 'contexts/movements'
import { MeContext } from 'contexts/me'
import { useNavigate } from 'react-router-dom'
import { useActivityIDStore } from 'store'
import WORDING from 'constants/wording'
import { ACT_TYPES } from 'constants/activities'
import Skeleton from 'react-loading-skeleton'
import useViewport from 'hooks/useViewport'
import MovementDetail from 'components/MovementDetail'
import FilterModal from 'components/FilterModal'
import ModalContainer from 'components/ModalContainer'
import TransferActivityDetailModal from 'pages/cashout/components/TransferActivityDetailModal'
import FallbackError from 'components/FallbackError'
import EmptySection from 'components/EmptySection'
import MovementsList from './MovementsList'
import MovementsItem from './MovementsItem'
import Pagination from './Pagination'

const { BANK_TRANSFER_OUT } = ACT_TYPES
const { MOVIMIENTOS } = WORDING

const MovementsListContainer = ({ isTransfer = false }) => {
  const [isFilterModalOpen, setFilterModalOpen] = useState<boolean>(false)
  const [isDetailModalOpen, setDetailModalOpen] = useState<boolean>(false)
  const [isProofModalOpen, setProofModalOpen] = useState<boolean>(false)

  const { isMobile } = useViewport()
  const { updateActivityID } = useActivityIDStore()
  const navigate = useNavigate()

  const { me } = useContext(MeContext)
  const {
    activities,
    getActivityById,
    callActivities,
    isError,
    dateRange,
    setDateRange
  } = useContext(MovementsContext)

  const activitiesToShow = isTransfer
    ? activities?.filter((act) => act.type_original === BANK_TRANSFER_OUT)
    : activities

  const handleItemButton = (id) => {
    if (isTransfer) {
      updateActivityID(id)
      isMobile
        ? navigate('/ver-detalle-transferencia')
        : setProofModalOpen(true)
    } else {
      getActivityById(id)
      isMobile ? navigate('/ver-detalle-movimientos') : setDetailModalOpen(true)
    }
  }

  return (
    <>
      <MovementsList
        title={MOVIMIENTOS}
        isError={isError}
        filterClick={() =>
          isMobile ? navigate('/filtrar-movimientos') : setFilterModalOpen(true)
        }
      >
        {isError ? (
          <FallbackError className='-mt-3' type='tus movimientos' />
        ) : null}
        {!isError &&
          activities &&
          activitiesToShow.map((act) => (
            <MovementsItem
              isTransfer={isTransfer}
              act={act}
              key={act.id}
              handleClick={() => {
                handleItemButton(act.id)
              }}
            />
          ))}
        {!isError && !activities && (
          <Skeleton height={56} count={3} className='mb-2' />
        )}
        {!isError && activities?.length === 0 && (
          <EmptySection section='MOVEMENTS' />
        )}
      </MovementsList>
      {!isError && activities && (
        <>
          {/* Movements Pagination */}
          <Pagination />
        </>
      )}
      {/* Modals */}
      <FilterModal
        dateRange={dateRange}
        setDateRange={setDateRange}
        isShown={isFilterModalOpen}
        setModalFunction={setFilterModalOpen}
        filterFunction={() =>
          callActivities({
            walletUUID: me?.bank?.internal_account[0]?.wallet_account
          })
        }
      />

      <ModalContainer
        isShown={isDetailModalOpen}
        title='Detalles de movimientos'
        className='md:min-w-[30rem]'
        setModalFunction={setDetailModalOpen}
      >
        <MovementDetail />
      </ModalContainer>

      <TransferActivityDetailModal
        setShowModal={setProofModalOpen}
        showModal={isProofModalOpen}
      />
    </>
  )
}

export default MovementsListContainer
